import { 
    // call,
    put, takeLatest, delay } from "redux-saga/effects";
import ActionTypeConstants from "helpers/ActionTypeConstants";
// import { actionApiCall } from "helpers/api/ApiCalls";

function* loadImportantDocumentsSaga({ payload }) {
    try {
        // const apiResponse = yield call(actionApiCall, {
        //     actionType: ActionTypeConstants.LOAD_IMPORTANT_DOCUMENTS,
        //     data: {
        //         organization: 1,
        //         site: 1,
        //     }
        // });
        // if (apiResponse.res.data.response === 200) {
        //     const { data } = apiResponse.res.data;
        //     yield put({
        //         type: ActionTypeConstants.LOAD_IMPORTANT_DOCUMENTS_SUCCESS,
        //         payload: {
        //             "important-documents": data
        //         }
        //     });
        //     yield put({
        //         type: ActionTypeConstants.LOAD_IMPORTANT_DOCUMENTS_SUCCESS,
        //         payload:
        //         {
        //             "important-documents": [...Array(100)].map((el, index) => ({
        //                 id: index,
        //                 index,
        //                 "document-name": 'static text',
        //                 created: '2019-11-15',
        //                 revised: '2019-11-15',
        //                 expires: '2019-11-15',
        //                 status: Math.round(Math.random()) ? "New" : "Complete"
        //             }))
        //         }
        //     });
        // } else {
        //     yield put({
        //         type: ActionTypeConstants.SHOW_ALERT,
        //         payload: {
        //             message: apiResponse.res.data.message || "An issue occurred while loading documents",
        //             color: "danger"
        //         }
        //     });
        //     yield delay(10000)
        //     yield put({ type: ActionTypeConstants.HIDE_ALERT });
        // }
    } catch (err) {
        yield put({
            type: ActionTypeConstants.SHOW_ALERT,
            payload: {
                message: "An issue occurred while loading documents",
                color: "danger"
            }
        });
        yield delay(10000)
        yield put({ type: ActionTypeConstants.HIDE_ALERT });
    }
}

export default function*() {
    yield takeLatest(ActionTypeConstants.LOAD_IMPORTANT_DOCUMENTS, loadImportantDocumentsSaga);
}
